<template>
    <v-container transparent>
        <v-layout>
            <v-card class="report-wrapper-s" width="100%" flat>
                <v-card-title class="pa-4 title">Тест отчета с сервера</v-card-title>
                <button @click="downloadPdf">Download PDF</button>
                {{ lang }}
                <span v-html="reportBody"></span>

            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import scriptjs from 'scriptjs'



    export default {
        name: "ServerReport",
        props: ['lang'],
        data: () => ({
            reportBody: "",
            reportData: {}
        }),
        watch: {
          lang: function() {
            this.loadAndRender()
          }
        },
        methods: {
            downloadPdf() {
            },
            loadAndRender() {
                var that =this
                this.$http.get('/report?reportId=testReport&reportTemplate=generic&lang='+this.lang, {data: {reportId:'testReport'}} ).then(function (response) {
                    that.reportBody = response.data.renderResult
                    that.reportData = response.data.data

                    let config = that.reportData
                    for(let item in config.reportSchema.js.scripts){
                        scriptjs(config.reportSchema.js.scripts[item])
                    }
                    window.reportData = {}
                    window.reportData[config.reportSchema.id] = config

                    // eslint-disable-next-line
                    console.log(config.reportSchema.wwwBaseDir + '/' + config.reportSchema.id + '/' + config.reportSchema.js.process, '49')

                    scriptjs(config.reportSchema.wwwBaseDir + '/' + config.reportSchema.id + '/' + config.reportSchema.js.process, 'cli')
                    scriptjs.ready('cli', function(){
                        setTimeout(()=>{processData(window.reportData[config.reportSchema.id])}, 1000 )
                    })

                });

            }
        },
        created: function () {},
        mounted: function() {
            this.loadAndRender()
        }

    }
</script>

<style lang="scss">
    .report-wrapper-s {
        background: transparent !important;
    }
</style>